import React, { useState, useEffect } from "react";
//import { confirm } from "react-confirm-box";
import axios from 'axios';
import {Link, NavLink } from "react-router-dom";
import { useLocation } from "react-router";
import $ from 'jquery';
import saveAs from 'file-saver';
import { useNavigate } from 'react-router-dom'
import cssclass from "./cssclass";
//var dateFormat = require('dateformat');

	

const RenderWpForm = () => {

const navigate = useNavigate();
	

/*
had an error with sessionStorage.getItem("RESTURL") returning null 
when below declaration was before this const RenderWpForm
*/
const resturl=sessionStorage.getItem("RESTURL");
const customspremurl=sessionStorage.getItem("CUSTOMSPREMURL");
const AD_USER=sessionStorage.getItem("AD_USER")??"";
//var boolFetchingSads=false;


//getresturl();



window.addEventListener("keypress", function (event) {
 // detect event keys
 if (event.keyCode == 13) {
   //callsadfinder();
   
 }
});


const navWpform = React.useRef();
const navWpvouchers = React.useRef();

//const [wptappfetchparams, setWptappfetchparams] = useState({});
const [laborclrstatus, setLaborclrstatus] = useState([]);
const [schoolopts, setSchoolopts] = useState([]);


const [arrmonthspan, setArrmonthspan] = useState([]);
const [combotype, setCombotype] = useState([]);
const [agencyoptions, setAgencyoptions] = useState([]);
const [apptypeoptions, setApptypeoptions] = useState([
<option key="apptype_1" value='First Time' >First Time</option>	
,<option key="apptype_2"  value='New' >New</option>	
,<option key="apptype_3"  value='Renewal' >Renewal</option>	
]);

const [tbloverduewptapps, setTbloverduewptapps] = useState([]);
const [tbldeferrows, setTbldeferrows] = useState([]);
const [tbloverdueappsmm, setTbloverdueappsmm] = useState([]);
const [tbloverdueappssta, setTbloverdueappssta] = useState([]);
const [wrkpmtstatusrows, setWrkpmtstatusrows] = useState([]);
const [searchresapps, setSearchresapps] = useState([]);


const [overdueappcrit, setOverdueappcrit] = useState({yer:"", sta:""});


/*
const [arraycaseworker, setArraycaseworker] = useState([]);
const [combocaseworker, setCombocaseworker] = useState([]);



const [incompcritlocation, setIncompcritlocation] = useState([]);
const [incompcritprocarea, setIncompcritprocarea] = useState([]);
const [incompcritusername, setIncompcritusername] = useState([]);
const [incompcritarrayuser, setIncompcritarrayuser] = useState([]);

*/


const [dowait, setDowait] = useState({show:true});
const [dowaitincompl, setDowaitincompl] = useState({show:true});

const [wptapp, setWptapp] = useState({WPT_APP_ID:""});
const [tabmenu, setTabmenu] = useState({STATUS:""});

const [tblwptapps, setTblwptapps] = useState({
loaded:false
,APS_NEWS_DATE:""
,newrows:[]
,unpdrows:[]
,revwdrows:[]
,apprvdrows:[]
,wrkpmtrows:[]
,wpcardrows:[]
,processingrows:[]
,rfsdrows:[]
,lcappealrows:[]
});

let tblwptappsreset={};

const [linkwpform, setLinkwpform] = useState({WPT_APP_ID:0});
const [linkvouchers, setLinkvouchers] = useState({WPT_APP_ID:0});

const [statuscounts, setStatuscounts] = useState({
 NEW: 0 
 , UNPAID: 0 
 , PAID: 0 
 , PROCESSING: 0 
 , APPROVED: 0 
 ,  WORK_PERMIT: 0 
 , WP_CARD: 0  
 , REFUSED: 0 
 , APPEALED: 0 
 , TOTAL_ROW_COUNT: 0
});

const [searchcrit, setSearchcrit] = useState({
	txt: sessionStorage.getItem("searchcrit.txt")??""
	, cw:sessionStorage.getItem("ASSIGNED_TO_CW")??""
	, months_span: ""
	, YRMM1: ""
	, YRMM2: ""
	, tcisland: sessionStorage.getItem("searchcrit.tcisland")??(sessionStorage.getItem("TC_ISLAND")??"PROVIDENCIALES")
	, processarea: sessionStorage.getItem("searchcrit.processarea")??(sessionStorage.getItem("PROCESS_AREA")??"")
	, boardreview: ""
	, nonagency: ""
	, critname: ""
	, AGENCY:""
	, APP_TYPE:""
	, LETTER_RANGE:""
	});
	

/*
const [incomplcrit, setIncomplcrit] = useState({
	yrmm:""
	, date1:""
	, date2: ""
	, rptoffice: searchcrit.tcisland
	, rptcaseworker:""
	, rptprocessarea: searchcrit.processarea
	, awaiting:""
	});	

*/

	
const [combodates, setCombodates] = useState([]);
const [officeopts, setOfficeopts] = useState([]);


const [processareaopts, setProcessareaopts] = useState([
<option value='' key='procopt1' ></option>
,<option value='General' key='procopt2'  >General</option>
,<option value='Corporate' key='procopt3'  >Corporate</option>
]);


const startupMins='05';//here on test page this will be 10 seconds
let numticks=0;
const [ticks, setTicks] = useState({num:0});
const [city, setCity] = useState({name:''});

const [countdown, setCountdown] = useState({min:startupMins,sec:'00'});



const location = useLocation();
let reloadTimer=null;
//var currmins=10;
const timerEvent = () => {
	numticks+=1;
	const newticks=numticks;
	//console.log('numticks:'+numticks);
	//console.log('newticks:'+newticks);
	setTicks({num:newticks});
};


useEffect(() => {
//console.log('useEffect resturl: '+sessionStorage.getItem("RESTURL"));

if (sessionStorage.getItem("USERNAME")==null || sessionStorage.getItem("USERNAME")=="null" || sessionStorage.getItem("USERNAME")==undefined || sessionStorage.getItem("USERNAME")==""){
	navigate("/");
	return;
	}//end if


document.title =   "APS Applications";	
tblwptappsreset=tblwptapps;

getarrmonthspan();
//callrptincomplwptapps(null);
const boardreview=sessionStorage.getItem("searchcrit.boardreview")??"";
const nonagency=sessionStorage.getItem("searchcrit.nonagency")??"";

if (boardreview=="B" && document.getElementById("cbboardrvw")){
	document.getElementById("cbboardrvw").checked=true;
	setSearchcrit((prev)=>{
		return {...prev, boardreview:boardreview}
	});
	}//end if
if (nonagency=="N" && document.getElementById("cbnonagency")){
	document.getElementById("cbnonagency").checked=true;
	setSearchcrit((prev)=>{
		return {...prev, nonagency:nonagency}
	});
	}//end if



console.log("reloadTimer: "+reloadTimer);
if (reloadTimer==null)
	reloadTimer = setInterval(timerEvent, 1000);//*60
else{

	}//end else

// Stops the old timer when umount the component.
return function stopTimer() {
	  console.log("cleaning up");
  clearInterval(reloadTimer);
}


 },[]);



useEffect(() => {

if (countdown.min==startupMins && countdown.sec=='00'){
	
	/*reload the table either directly or by clearing criteria*/
	if (searchcrit.txt=="" && searchcrit.months_span!="" && searchcrit.tcisland!="" && officeopts.length>0){
		getwptappstatuscounts();
		}//end if
	else if (tblwptapps==true && searchcrit.txt!=""){
		if (document.getElementsByName("schoolname")[0])
			document.getElementsByName("schoolname")[0].value='';
		const args={
			target:{name:"txt", value:""}
			};
		searchcritChange(args);
		}//end if
		
		//setSearchcrit((prev)=>{	return {...prev, txt:""} });
	
	
	//if (city.name=='')
		//openDefaultDefaultCity();
	}//end if
	
	
//console.log("ticks.num: "+ticks.num);
	if (1*countdown.min==0 && countdown.sec=='01')
		setCountdown({min:startupMins,sec:'00'});
	else{
		const newsec=countdown.sec=='00'?59:(1*countdown.sec)-1;
		const tempmin=1*countdown.min-((newsec==59)?1:0);
		//console.log("tempmin: "+tempmin);
		const newmin=tempmin<0?(1*startupMins)-1:tempmin;
		const padd=newsec<10?"0":"";
		setCountdown({min:""+newmin,sec:padd+newsec});
		}

 },[ticks.num]);


		

useEffect(() => {

if (combodates.length>0 && searchcrit.months_span==""){
	//const FIRST_MONTHS_SPAN = document.getElementsByName("FIRST_MONTHS_SPAN")[0].value;
	setSearchcrit((prev)=>{
		return {...prev
			, months_span: arrmonthspan[0].MONTHS_SPAN
			, YRMM1: arrmonthspan[0].YRMM1
			, YRMM2: arrmonthspan[0].YRMM2
			}
		});
	}//end if
	

 },[JSON.stringify(combodates)]);
	

useEffect(() => {

if (arrmonthspan.length>0 && combodates.length==0)
	writeCombodates();

 },[JSON.stringify(arrmonthspan)]);

	


useEffect(() => {

if (tbloverdueappsmm.length>0 && tbloverdueappssta.length==0)
	gettbloverdueappssta();

 },[JSON.stringify(tbloverdueappsmm)]);


useEffect(() => {

if (wrkpmtstatusrows.length>0)
	document.getElementById("tblWrkpmtstatusInput1").focus();

 },[JSON.stringify(wrkpmtstatusrows)]);





useEffect(() => {

if (overdueappcrit.yer!="" || overdueappcrit.sta!="")
	tblincomplwptapps();
//incomplcrit
 },[overdueappcrit]);
 
 
 
 useEffect(() => {

if (tblwptapps.loaded==true && schoolopts.length==0)
	getschoolopts();

 },[tblwptapps.loaded]);
 
 




 
  useEffect(() => {
	 //if (dowait.show==false)
		//openDefaultCity();
 },[dowait.show]);
 
 useEffect(() => {
	if (linkwpform.WPT_APP_ID>0)
		navWpform.current?.click();
 },[linkwpform]);

 

useEffect(() => {
	if (linkvouchers.WPT_APP_ID>0)
		navWpvouchers.current?.click();
 },[linkvouchers]);



useEffect(() => {
	
	//check officeopts as indication of lcrstartoptions status
	if (combodates.length>0 && officeopts.length==0)
		getlcrstartoptions();
	
 },[JSON.stringify(combodates)]);
 
useEffect(() => {
/*
chain of command to call getwptappstatuscounts() after getlcrstartoptions() is
officeopts.length triggers openCity(evt, cityName)
city.Name triggers setTabmenu
tabmenu.STATUS triggers getwptappstatuscounts();
*/	
	if (officeopts.length>0){
		const evt={currentTarget:document.getElementById("newapps")};
		openCity(evt, "newappstc");
		}//end if
		
	
 },[JSON.stringify(officeopts)]);


 useEffect(() => {
	
	console.log("statuscounts.TOTAL_ROW_COUNT: "+statuscounts.TOTAL_ROW_COUNT);
	
	if (statuscounts.TOTAL_ROW_COUNT>0)
		gettblwptapps();
		
 },[statuscounts.TOTAL_ROW_COUNT]);

useEffect(() => {
	
	console.log("tabmenu.STATUS: "+tabmenu.STATUS);
	console.log("searchcrit.YRMM2: "+searchcrit.YRMM2);
	console.log("officeopts.length: "+officeopts.length);
	console.log("statuscounts.TOTAL_ROW_COUNT: "+statuscounts.TOTAL_ROW_COUNT);

	if (!tabmenu.STATUS)
		return;

	if (tabmenu.STATUS=="")
		return;

	if (officeopts.length==0)
		return;

	if (searchcrit.YRMM1=="" || searchcrit.YRMM2=="")
		return;
	
	if (statuscounts.TOTAL_ROW_COUNT==0)
		getwptappstatuscounts();
	else
		gettblwptapps();
		
	
	
 },[tabmenu.STATUS, searchcrit.YRMM1]);
 
 
 
 useEffect(() => {
	
	
	//console.log("searchcrit useEffect critname: "+searchcrit.critname);
	//console.log("searchcrit.LETTER_RANGE: "+searchcrit.LETTER_RANGE);
	
	if (searchcrit.critname=="txt" || searchcrit.critname=="LETTER_RANGE")
		return;

	if (searchcrit.YRMM1=="" || searchcrit.YRMM2=="")
		return;
	
		if (officeopts.length==0)
			return;
		getwptappstatuscounts();
	
 },[searchcrit]);
 
 



useEffect(() => {
	
console.log("city.name: "+city.name);
if (city.name=="newappstc" )
	setTabmenu((prev)=>{
	return {...prev, STATUS:"NEW"}
	});
else if (city.name=="unpaidappstc" )
	setTabmenu((prev)=>{
	return {...prev, STATUS:"UNPAID"}
	});
else if (city.name=="newlypaidappstc" )
	setTabmenu((prev)=>{
	return {...prev, STATUS:"PAID"}
	});
else if (city.name=="processingappstc" )
	setTabmenu((prev)=>{
	return {...prev, STATUS:"PROCESSING"}
	});
else if (city.name=="approvedappstc" )
	setTabmenu((prev)=>{
	return {...prev, STATUS:"APPROVED"}
	});
else if (city.name=="wrkpmtappstc" )
	setTabmenu((prev)=>{
	return {...prev, STATUS:"WORK_PERMIT"}
	});
else if (city.name=="wpcardappstc" )
	setTabmenu((prev)=>{
	return {...prev, STATUS:"WP_CARD"}
	});
else if (city.name=="refusedappstc" )
	setTabmenu((prev)=>{
	return {...prev, STATUS:"REFUSED"}
	});
else if (city.name=="lcappealappstc" )
	setTabmenu((prev)=>{
	return {...prev, STATUS:"APPEALED"}
	});

/*
if (city.name=="overduelcrwpttc" && tbloverdueappsmm.length==0)
	//tblincomplwptapps() ;
	getincomplwptappsmm();

*/	
		
 },[city.name]);







async function getschoolopts(){
console.log("getschoolopts");

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {})
  };		

setSchoolopts([]);

  await fetch(resturl+'rarwpform/getschoolopts',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergetschoolopts(res) )
      .catch(err => console.log(err));

}//end func

function aftergetschoolopts(res){

if (!res.length)
	return;

let temp=[];

res.map((col, index) => {
	const key="schoolopt_"+index;
	temp.push(<option key={key} value={col['COMPANY']} >{col['COMPANY']}</option>);

	});//end map

setSchoolopts(temp);

}//end func

function handleIncompcritchange(e){
//clear_filter.png;

console.log("handleIncompcritchange: "+e.target.name);

if (e.currentTarget.name=="rdincomplsta0" || e.currentTarget.name=="rdincomplyrs0")
	e.preventDefault();


if (e.currentTarget.name=="rdincomplsta0"){
	const len = document.getElementsByName("rdincomplsta").length;
	for (var i=0; i<len; i++)
		document.getElementsByName("rdincomplsta")[i].checked=false;
	setOverdueappcrit((prev)=>{
		return {...prev, sta:""}
		});	
	
	if (!document.getElementById("rdincomplsta0").classList.contains("hidden"))
		document.getElementById("rdincomplsta0").classList.add("hidden");
	setTbloverduewptapps([]);
	return;
	}//end if

if (e.currentTarget.name=="rdincomplyrs0"){
	const len = document.getElementsByName("rdincomplyrs").length;
	for (var i=0; i<len; i++)
		document.getElementsByName("rdincomplyrs")[i].checked=false;
	setOverdueappcrit((prev)=>{
		return {...prev, yer:""}
		});	

	if (!document.getElementById("rdincomplyrs0").classList.contains("hidden"))
		document.getElementById("rdincomplyrs0").classList.add("hidden");
	setTbloverduewptapps([]);
	return;
	}//end if
	
	

if (e.target.name.startsWith("rdincomplsta")){
	setOverdueappcrit((prev)=>{
		return {...prev, sta:e.target.value}
		});
	if (document.getElementById("rdincomplsta0").classList.contains("hidden"))
		document.getElementById("rdincomplsta0").classList.remove("hidden");
	}//end if

if (e.target.name.startsWith("rdincomplyrs")){
	setOverdueappcrit((prev)=>{
		return {...prev, yer:e.target.value}
		});
	
	if (document.getElementById("rdincomplyrs0").classList.contains("hidden"))
		document.getElementById("rdincomplyrs0").classList.remove("hidden");
	}//end if
	
}//end func

async function gettbloverdueappssta(){

let params = overdueappcrit;
params.office=searchcrit.tcisland==""?sessionStorage.getItem("TC_ISLAND")??"":searchcrit.tcisland;
params.processarea=searchcrit.processarea==""?sessionStorage.getItem("PROCESS_AREA")??"":searchcrit.processarea;
params.username = sessionStorage.getItem("USERNAME");
params.yrmm="";

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };		

setTbloverdueappssta([]);

  await fetch(resturl+'rarwpform/getincomplwptappsta',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergettbloverdueappssta(res) )
      .catch(err => console.log(err));

}//end func

function aftergettbloverdueappssta(res){

if (!res.length)
	return;

let temprows=[];
let appcount=0;
//let rowhtm=[];
res.map((col, index) => {
	
	const trkey="incomplappsta_"+index;
	const rdId="rdincomplsta_"+index;
		
	temprows.push(
		<tr key={trkey} >
		
		<td align='right' style={{width:"200px"}} >
			<input type="radio" name="rdincomplsta" id={rdId} value={col['STATUS']} onClick={(e)=>{handleIncompcritchange(e);}} />
			<label htmlFor={rdId} className="hand" >{col['STATUS']}</label>
		</td>
		<td align='right' >{col['COUNT01']}</td>
		<td align='right' >{col['COUNT02']}</td>
		<td align='right' >{col['COUNT03']}</td>
		<td align='right' >{col['COUNT04']}</td>
		<td align='right' >{col['COUNT05']}</td>
		<td align='right' >{col['COUNT06']}</td>
		<td align='right' >{col['COUNT07']}</td>
		<td align='right' >{col['COUNT08']}</td>
		<td align='right' >{col['COUNT09']}</td>
		<td align='right' style={{width:"100px"}} >{col['APP_COUNT']}</td>
		</tr>);
	
	appcount+=col['APP_COUNT'];
	
	});//end map


temprows.push(<tr key="incomplappsta_xxx" ><th align='right' colSpan="10" >Total # of Applications:</th><th align='right'>{appcount}</th></tr>);

console.log("temprows.length: "+temprows.length);
setTbloverdueappssta(temprows);

}//end func








async function getlcrstartoptions(){

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {} )
  };		

 await fetch(resturl+'rarwptprocess/getlcrstartoptions',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergetlcrstartoptions(res) )
      .catch(err => console.log(err));

}//end func



function aftergetlcrstartoptions(res){
	console.log("aftergetlcrstartoptions res.length: "+res.length);
//copied from lbr_clr_app.js
let tempcombotype=[];
let tempstatusoptions=[];
let tempagencyopts=[];
let tempofficeopts=[];


res.map((col, index) => {
	const combo=col['COMBO'];
	const key=combo+"_"+index;
	const opt=col['OPT'];
	const val=col['VAL'];
	
	
	if (combo=='status')
		tempstatusoptions.push(<option key={key} value={val}  >{opt}</option>);
	else if (combo=='lctype')//wptype
		tempcombotype.push(<option key={key} value={val}  >{opt}</option>);
	else if (combo=='agency')//agency
		tempagencyopts.push(<option key={key} value={opt}  >{opt}</option>);
	else if (combo=='immigoffice')
		tempofficeopts.push(<option key={key} value={opt}  >{opt}</option>);

	});//end map

console.log("tempagencyopts.length: "+tempagencyopts.length);

setOfficeopts(tempofficeopts);
setCombotype(tempcombotype);
setAgencyoptions(tempagencyopts);
}//end func




function getresturl(){
console.log('getresturl( location.state: '+JSON.stringify(location.state))	;
for(var attributename in location.state){
	if (attributename=='resturl')
		return location.state.resturl;
	}//end for	
return null;	
}//end func




async function getarrmonthspan(){

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {} )
  };		

setCombodates([]);
setArrmonthspan([]);

  await fetch(resturl+'rarwpform/getcombodates',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergetarrmonthspan(res) )	
	
}//end func


function aftergetarrmonthspan(res){
	
	
let temp=[];

res.map((col, index) => {
	temp.push({
		YRMM1: col['YRMM1']
		,YRMM2: col['YRMM2']
		,MONTHS_SPAN: col['MONTHS_SPAN']
		});

	//if (index==0)
		//document.getElementsByName("FIRST_MONTHS_SPAN")[0].value=col['MONTHS_SPAN'];

	});//end map

setArrmonthspan(temp);
	
}//end func

function writeCombodates(){
	
	
let temp=[];

arrmonthspan.map((col, index) => {
	const key="months_span_"+index;
	const MONTHS_SPAN = col['MONTHS_SPAN'];
	temp.push(<option key={key} value={MONTHS_SPAN}  >{MONTHS_SPAN}</option>);

	});//end map

setCombodates(temp);
	
}//end func


async function incompl_app_by_cswkr(e){

e.preventDefault();

const jsonParams={
	 OFFICE: searchcrit.tcisland
	, PROCESS_AREA: searchcrit.processarea
	, YRMM1: searchcrit.YRMM1
	, YRMM2: searchcrit.YRMM2
	, AGENCY: searchcrit.AGENCY
	, APP_TYPE: searchcrit.APP_TYPE
	, LETTER_RANGE: searchcrit.LETTER_RANGE
	, STATUS: tabmenu.STATUS
	, DAYS_OLD: "21"
	};

console.log("incompl_app_by_cswkr: "+JSON.stringify(jsonParams));
	
const CREATE_USER=sessionStorage.getItem("USERNAME")??"";
const resFilePath="C:\\scripts\\ireports\\out\\Applications_Not_Completed_Report.pdf";
//2026 08 23 Azure was blocking and got it fixed in PostMan by changing && to &
let lsargs="", lsvals="";
for(var attributename in jsonParams){
		const data=jsonParams[attributename]??"";
		if (lsargs!=""){
			lsargs+=",";
			lsvals+=",";
			}
		lsargs+=attributename;
		lsvals+=data;
	}//end for	

const paramsurl="reportfilepath=C:\\scripts\\ireports\\incompl_app_by_cswkr.jasper"+
				"&resultfilepath="+resFilePath+
				"&lsargs="+lsargs+
				"&lsvals="+lsvals;
				
				//note: lsvals and lsargs are comma separated values lists

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {paramsurl:paramsurl} )
  };		

cssclass(e.target.id, "hidden", 1);

 await fetch(resturl+'rarwpform/jaspertopdf',requestOptions)
 	.then(res => res.json())
      .then(res => 	afterincompl_app_by_cswkr(res, e) )
      .catch(err => console.log(err));


}//end func


async function afterincompl_app_by_cswkr(res, e){

cssclass(e.target.id, "hidden", 0);


const strFile=res.length?(res[0].File??""):"";

if (strFile=="")
	window.alert("Error: No file was returned from the server");
else{
	//console.log("strFile: "+strFile);
	const downloadLink = document.createElement("a");
	downloadLink.href = 'data:application/octet-stream;base64,' + strFile;
	downloadLink.download = "Applications_Not_Completed_Report.pdf"
	downloadLink.click();
	}
	
	
}//end func


async function rptManwrtoffapps(e){

e.preventDefault();
	
const resFilePath="C:\\scripts\\ireports\\out\\ReportOfManuallyWrittenOffApps.pdf";
//2026 08 23 Azure was blocking and got it fixed in PostMan by changing && to &
const CREATE_USER=sessionStorage.getItem("USERNAME")??"";
const paramsurl="reportfilepath=C:\\scripts\\ireports\\rptManwrtoffapps.jasper"+
				"&resultfilepath="+resFilePath+
				"&lsargs=CREATE_USER,YRMM1,YRMM2,STATUS"+
				"&lsvals="+CREATE_USER+","+searchcrit.YRMM1+","+searchcrit.YRMM2+",MANWRITEOFF";
				//note: lsvals and lsargs are comma separated values lists

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {paramsurl:paramsurl} )
  };		

cssclass(e.target.id, "hidden", 1);

 await fetch(resturl+'rarwpform/jaspertopdf',requestOptions)
 	.then(res => res.json())
      .then(res => 	afterrptManwrtoffapps(res, e) )
      .catch(err => console.log(err));


}//end func


async function afterrptManwrtoffapps(res, e){

cssclass(e.target.id, "hidden", 0);


const strFile=res.length?(res[0].File??""):"";

if (strFile=="")
	window.alert("Error: No file was returned from the server");
else{
	console.log("strFile: "+strFile);
	const downloadLink = document.createElement("a");
	downloadLink.href = 'data:application/octet-stream;base64,' + strFile;
	downloadLink.download = "ReportOfManuallyWrittenOffApps.pdf"
	downloadLink.click();
	}
	
	
}//end func



function setCaseWorker(e){
	e.preventDefault();
   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {USERNAME:sessionStorage.getItem("USERNAME"), WPT_APP_ID:wptapp.WPT_APP_ID} )
  };		

  fetch(resturl+'rarwpform/setcaseworker',requestOptions)
      .then(res => res.json())
      .then(res => 	afterSetCaseWorker(res) )	
	
}//end func

function showsnackbar(innerHTML) {
  var x = document.getElementById("snackbar");
  x.innerHTML=innerHTML;
  x.className = "show";
  setTimeout(function(){ x.className = x.className.replace("show", ""); }, 2500);
}//end func


function afterSetCaseWorker(res){
if (res.length==undefined)
	showsnackbar("something went wrong.  please try again");
else{	
	showsnackbar("assigning case worker is complete");
	toggleModalsm();
	}
}//end func

function assignedToMe(e){
const USERNAME=sessionStorage.getItem("USERNAME");	
let caseworker=(e.target.checked==true)?USERNAME:"";
setSearchcrit((prev)=>{
	return {...prev, cw:caseworker}
});
sessionStorage.setItem("ASSIGNED_TO_CW", caseworker);

}//end func


function openlabourclearance(e, WPT_APP_ID, IPM_LBR_CLR_APP_ID, tempsearchresapps){
	

	e.preventDefault(); 
		navigate("/lbr_clr_app", {state:{BACK_PAGE:"wpapps", WPT_APP_ID:WPT_APP_ID, IPM_LBR_CLR_APP_ID:IPM_LBR_CLR_APP_ID, searchresapps:tempsearchresapps}});
	
	
}//end func


function submitSearchform(e){
	e.preventDefault();
	if (officeopts.length==0)
		return;	
	getwptappstatuscounts();
}//end func

async function getwptappstatuscounts(){

const EMAIL=sessionStorage.getItem("EMAIL");
console.log('EMAIL: '+EMAIL);


const ASSIGNED_TO_CW=sessionStorage.getItem("ASSIGNED_TO_CW")?sessionStorage.getItem("ASSIGNED_TO_CW"):"";
let CASE_WORKER=searchcrit.cw;//searchcrit.cw can be override by session
if (CASE_WORKER=="" && ASSIGNED_TO_CW!="")
	CASE_WORKER=ASSIGNED_TO_CW;


const USERNAME=sessionStorage.getItem("USERNAME")??"";
if (USERNAME==""){
	window.alert("abort getwptappstatuscounts because no login user was found");
	return;	
	}

if (searchcrit.YRMM1=="" || searchcrit.YRMM2==""){
	window.alert("abort getwptappstatuscounts because no dates filter is set");
	return;	
	}	


let params=searchcrit;
params.USERNAME=USERNAME;
params.CASE_WORKER=sessionStorage.getItem("CASE_WORKER")??"";
	
	  const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };		

setDowait({show:true});
setStatuscounts((prev)=>{
	return {...prev, TOTAL_ROW_COUNT:0}
	});
//setTabmenu({STATUS:""});
//openCity(null, null);
//console.log("tblwptappsreset: "+JSON.stringify(tblwptappsreset));
setTblwptapps(tblwptappsreset);
cssclass("btnsearch", "hidden", 1);

  await fetch(resturl+'rarwpform/getwptappstatuscounts',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergetwptappstatuscounts(res) )
      .catch(err => console.log(err));
	
}//end func
	
function aftergetwptappstatuscounts(res){

setDowait({show:false});
cssclass("btnsearch", "hidden", 0);

let params={
	NEW: 0
	, UNPAID: 0
	, UNPAID: 0
	, PAID: 0
	, PROCESSING: 0
	, APPROVED: 0
	, WORK_PERMIT: 0
	, WP_CARD: 0
	, REFUSED: 0
	, APPEALED: 0
};

for (var i=0; i<res.length; i++){
	if (res[i].STATUS=="NEW")
		params.NEW=res[i].STATUS_COUNT
	else if (res[i].STATUS=="UNPAID")
		params.UNPAID=res[i].STATUS_COUNT
	else if (res[i].STATUS=="PAID")
		params.PAID=res[i].STATUS_COUNT
	else if (res[i].STATUS=="PROCESSING")
		params.PROCESSING=res[i].STATUS_COUNT
	else if (res[i].STATUS=="APPROVED")
		params.APPROVED=res[i].STATUS_COUNT
	else if (res[i].STATUS=="WORK_PERMIT")
		params.WORK_PERMIT=res[i].STATUS_COUNT
	else if (res[i].STATUS=="WP_CARD")
		params.WP_CARD=res[i].STATUS_COUNT
	else if (res[i].STATUS=="REFUSED")
		params.REFUSED=res[i].STATUS_COUNT
	else if (res[i].STATUS=="APPEALED")
		params.APPEALED=res[i].STATUS_COUNT
	
	if (i==0)
		params.TOTAL_ROW_COUNT=res[i].TOTAL_ROW_COUNT
	
	}//end for

setStatuscounts({
 NEW: params.NEW
 , UNPAID: params.UNPAID
 , PAID: params.PAID
 , PROCESSING: params.PROCESSING
 , APPROVED: params.APPROVED
 ,  WORK_PERMIT: params.WORK_PERMIT
 , WP_CARD: params. WP_CARD
 , REFUSED: params.REFUSED
 , APPEALED: params.APPEALED
 , TOTAL_ROW_COUNT: params.TOTAL_ROW_COUNT
});

}//end func


async function gettblwptapps(){


const USERNAME=sessionStorage.getItem("USERNAME")??"";
if (USERNAME==""){
	window.alert("abort gettblwptapps because no login user was found");
	return;	
	}
	
if (searchcrit.YRMM1=="" || searchcrit.YRMM2==""){
	window.alert("abort gettblwptapps because no dates filter is set");
	return;	
	}	

if (tabmenu.STATUS==""){
	window.alert("abort gettblwptapps because no STATUS filter is set");
	return;	
	}	



let params=searchcrit;
params.STATUS=tabmenu.STATUS;
params.USERNAME=USERNAME;
params.CASE_WORKER=sessionStorage.getItem("CASE_WORKER")??"";

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };		

setDowait({show:true});
cssclass("btnsearch", "hidden", 1);
//setTblwptapps([]);

  await fetch(resturl+'rarwpform/gettblwptapps',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergettblwptapps(res) )
      .catch(err => console.log(err));

}//end func


function aftergettblwptapps(res){

setDowait({show:false});
cssclass("btnsearch", "hidden", 0);

if (!res.length)
	return;
else if (res.length<1)
	return;

console.log('aftergettblwptapps, res.length: '+res.length);

let newrows=[], unpdrows=[], revwdrows=[], rfsdrows=[], processingrows=[], lcappealrows=[] ,apprvdrows=[] ,wrkpmtrows=[] ,wpcardrows=[];
let APS_NEWS_DATE="";
let tempsearchresapps=[];

res.map((col, index) => {
	tempsearchresapps.push({
		WPT_APP_ID:col['WPT_APP_ID']
		, IPM_LBR_CLR_APP_ID:col['IPM_LBR_CLR_APP_ID']
		, SEARCH_RES_ITEM:col['SEARCH_RES_ITEM']
		});
});
//console.log("tempsearchresapps: "+JSON.stringify(tempsearchresapps));
setSearchresapps(tempsearchresapps);

res.map((col, index) => {
	if (index==0 && document.getElementsByName("months_span")[0]){
		//--if there is exact match of REF_NUM, IMG_REF, PASSP_NBR OR NAME, we can skip the date filter
		document.getElementsByName("months_span")[0].disabled=false;
		const CRIT_MATCH_COUNT=col['CRIT_MATCH_COUNT']??0;
		console.log("CRIT_MATCH_COUNT: "+CRIT_MATCH_COUNT);
		 if (CRIT_MATCH_COUNT>0)
			 document.getElementsByName("months_span")[0].disabled=true;
				 
		}//end if
	if (APS_NEWS_DATE=="")
		APS_NEWS_DATE=col['APS_NEWS_DATE']
	
	const appid=col['WPT_APP_ID'];
	const refnum=col['REF_NUM'];
	const STATUS=col['STATUS_CODE'];
	const STATUS_GRP=col['STATUS_GRP'];
	const WORK_PERMIT_ID=col.WORK_PERMIT_ID??0;
	const IMGS_SENT_PREM=col.IMGS_SENT_PREM??"";
	
	
	
	const CORPORATE=col['CORPORATE'];
	const CASE_WORKER=col['CASE_WORKER'];
	const submitted=col['SUBMITTED_TO_CSC'];
	
	/*
const LATE_ALERT=!col['LATE_ALERT']?<img src="img/orangealert.png" border="0" style={{visibility:"hidden"}} />:<img src="img/orangealert.png" border="0" title="this application has not been processed after some time" />;
	console.log("LATE_ALERT: "+col['LATE_ALERT']);	
	*/
	
	//const viewed = col['STR_VIEWED_DATE_TIME'];
	const trkey='tr_'+appid;
	//const rdkey='rd_'+appid;
	const ALLOW_TO_PROCESS=col['ALLOW_TO_PROCESS'];
	
	const foldericon=ALLOW_TO_PROCESS==1?'img/folderyel.png':'img/foldergrey.png';
	let dfrLink=col['FLAG_DEFERRED']==1?<a href="#" onClick={(e)=>{gettbldefers(e, appid);}} title="Deferred! Click here to see" ><img src="img/handwait.png" border="0" /></a>:<img src="img/handwait.png" className="hidden" />;
	if (col['STATUS_GRP']=="APPEALED")
		dfrLink=<span className='tooltip' ><a href="#" onClick={(e)=>{getlcappealletter(e, col['IPM_LBR_CLR_APP_ID'], col['UPLOAD_DIR']);}} title="download Appeal Letter" ><span className='tooltiptext'>download appeal letter</span><img src="img/pdf.gif" border="0" /></a></span>;
	else if (col['STATUS_GRP']=="REFUSED")
		dfrLink=<a href="#" onClick={(e)=>{getlcletterfilepath(e, col['IPM_LBR_CLR_APP_ID']);}} title="download Labour Clearance Letter" ><img src="img/pdf.gif" border="0" /></a>;
		
	
	let refnumLink=<a href="#" className="nodecor" onClick={(e)=>{handleWpappChange(e, appid, ALLOW_TO_PROCESS);}} ><img src={foldericon} height='18' border='0' />&nbsp;{refnum}</a>;
		{/*<span className='tooltiptext'>open this application</span>*/}
	
	//const pdflink=sessionStorage.getItem("UPLOADURL")+refnum+"/coverpage.pdf";	
	
	{/* <td align='left' className='tooltip' >&nbsp;{refnumLink}</td> */}
	//let lbr_clr_link=<></>;
	if (AD_USER!=""){
		//if (col['STATUS_GRP'].startsWith("PROCESSI") || col['STATUS']=="APPROVED" || col['STATUS_GRP'].startsWith("AWAITING") ){
		if (col['OPEN_LBR_CLR_APP']==1){
			const IPM_LBR_CLR_APP_ID=col['IPM_LBR_CLR_APP_ID']??0;
			if (IPM_LBR_CLR_APP_ID>0){
				refnumLink=<a href="#" title="open labour clearance" onClick={(e)=>{openlabourclearance(e, col['WPT_APP_ID'], IPM_LBR_CLR_APP_ID, tempsearchresapps) }} className="nodecor" ><img src={foldericon} border="0" height="18" />&nbsp;{refnum}</a>;
				dfrLink=<></>;
				}//end if
			
			}//end if
		}//end if
		
	
	
	const htmrow=<tr key={trkey} >
	<td align='right' >{col['ROW_NUM']}</td>
	<td align='left' >&nbsp;{refnumLink}</td>
	<td align='left' >{col['INITIALS']}</td>
	<td align='left' title={col['STATUS_GRP']} >{dfrLink}&nbsp;{col['STATUS']}</td>
	<td align='right' >{col['BAL_RCP_COUNT']}</td>
	<td align='center' >{col['SUBMITTED_TO_CSC']}</td>
	<td align='left' >{col['APP_TYPE']}</td>
	<td align='left' >{col['LCODE']}</td>
	<td align='left' >{col['AGENCY']}</td>
	<td align='left' >{col['MPR_NAME']}</td>
		{/*<td align='left' >{col['MPR_TEL_NBR']}</td>*/}
	<td align='left' >{col['IMG_REF']}</td>
	<td align='left' >
		{
			AD_USER=="ajones" && WORK_PERMIT_ID>0 && <>
			<a href="#" onClick={(e)=>{querywrkpmtstatus(e, WORK_PERMIT_ID, IMGS_SENT_PREM);}} ><img src="img/search.png" border="0" height="11" /></a>
			</>
		}
		{col['MPE_NAME']}
		
	</td>
	<td align='left' >{col['MPE_OCCUPATION']}</td>
		{/*<td align='right' className="tooltip" >{voucherLink}&nbsp;</td>*/}
	<td align='center' >{col['VIEWED_DATE_TIME']}</td>
	</tr>;
	
	
	if (STATUS_GRP=='NEW' && tabmenu.STATUS=="NEW")
		newrows.push(htmrow);
	else if (STATUS_GRP=='UNPAID' && tabmenu.STATUS=="UNPAID")
		unpdrows.push(htmrow);
	else if (STATUS_GRP=='PAID' && tabmenu.STATUS=="PAID")
		revwdrows.push(htmrow);
	else if (STATUS_GRP=='PROCESSING' && tabmenu.STATUS=="PROCESSING")
		processingrows.push(htmrow);
	else if (STATUS_GRP=='APPROVED' && tabmenu.STATUS=="APPROVED")
		apprvdrows.push(htmrow);
	else if (STATUS_GRP=='WORK_PERMIT' && tabmenu.STATUS=="WORK_PERMIT")
		wrkpmtrows.push(htmrow);
	else if (STATUS_GRP=='WP_CARD' && tabmenu.STATUS=="WP_CARD")
		wpcardrows.push(htmrow);
	else if (STATUS_GRP=='REFUSED' && tabmenu.STATUS=="REFUSED")
			rfsdrows.push(htmrow);
	else if (STATUS_GRP=='APPEALED' && tabmenu.STATUS=="APPEALED")
			lcappealrows.push(htmrow);
	
	else{
		processingrows.push(htmrow);
		/*
		The below if condition is removed so to capture all other status in this category
		we also have DENIED, AWAITING APPROVAL, and who knows what else
		if (STATUS=='PROCESSING' || STATUS=='DEFERRED' || STATUS=='WITHDRAWN' || STATUS=='APPROVED')
			SP_WPT_APP_STATUS_FRM_LCR
		*/ 
		}
		
	});


//console.log("processingrows: "+JSON.stringify(processingrows));

setTblwptapps({
loaded:true
,APS_NEWS_DATE:APS_NEWS_DATE
,newrows:newrows	
,unpdrows:unpdrows	
,revwdrows:revwdrows	
,apprvdrows:apprvdrows
,wrkpmtrows:wrkpmtrows
,wpcardrows:wpcardrows
,processingrows:processingrows
,rfsdrows:rfsdrows
,lcappealrows:lcappealrows
});


}//end func



async function querywrkpmtstatus(e, WORK_PERMIT_ID, IMGS_SENT_PREM){
	
	e.preventDefault();
	
	   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {work_permit_id:WORK_PERMIT_ID} )
  };	
  
  setDowait({show:true});
  
  await  fetch(resturl+'rarmssql/querywrkpmtstatus',requestOptions)
      .then(res => res.json())
      .then(res => afterquerywrkpmtstatus(res, IMGS_SENT_PREM)	 )
      .catch(err => console.log(err));	
}//end func

async function afterquerywrkpmtstatus(res, IMGS_SENT_PREM){

setDowait({show:false});

const updated_date=res.length?(res[0].updated_date??""):"";
if (updated_date=="")
	window.alert("failed");
else{
	const arrFld="work_permit_id, work_permit_no, signat_length, last_name, first_name, full_name, employer, nationality, status, date_issue, expire_date, updated_by, updated_date, approved_by, approved_date, card_no, ActivityDateTime, ActivityCount".split(",");
	let htmrows=[<tr>
		<td align="right" >Imgs sent:</td>
		<td align="left" >{IMGS_SENT_PREM}</td>
		</tr>];
	htmrows.push(<tr>
		<td align="right" ><input id='tblWrkpmtstatusInput1' size='2' readOnly className="gnsbro" /></td>
		<td align="left" ><a href="#" onClick={(e)=>{setWrkpmtstatusrows([]);}} >close window</a></td>
		</tr>);
	
	for (var i=0; i<arrFld.length; i++){
		const fld=arrFld[i].trim();
		const htmrow=<tr>
				<td align="right" >{fld}:</td>
				<td align="left" >{res[0][fld]}</td>
				</tr>;
		htmrows.push(htmrow);
		
		if (fld=="work_permit_id")
			getwptphotoandsignat(res[0].fld??0);
		
		}//end for
	
	setWrkpmtstatusrows(htmrows);
	}//end else


}//end func






async function getwptphotoandsignat(WORK_PERMIT_ID){

console.log("getwptphotoandsignat WORK_PERMIT_ID: "+WORK_PERMIT_ID);

if (WORK_PERMIT_ID<1){
	setWptapp((prev)=>{
		return {...prev
			, SIGNAT: ""
			, PHOTO: ""
			};
		});	
	return;
	}//end if


   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {WORK_PERMIT_ID:WORK_PERMIT_ID} )
  };		

  //setDowait({show:true});
	
  await fetch(customspremurl+'rarmssql/getwptphotoandsignat',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergetwptphotoandsignat(res) )
      .catch(err => console.log(err));

}//end func


function aftergetwptphotoandsignat(res){
	
	//setDowait({show:false});
	
	setWptapp((prev)=>{
		return {...prev
			, SIGNAT:res[0].signat
			, PHOTO:res[0].foto
			};
		});
}//end func



async function getincomplwptappsmm(){

let params = overdueappcrit;
params.office=searchcrit.tcisland==""?sessionStorage.getItem("TC_ISLAND")??"":searchcrit.tcisland;
params.processarea=searchcrit.processarea==""?sessionStorage.getItem("PROCESS_AREA")??"":searchcrit.processarea;
params.username = sessionStorage.getItem("USERNAME");
	
	const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };		

  await fetch(resturl+'rarwpform/getincomplwptappsmm',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergetincomplwptappsmm(res) )
      .catch(err => console.log(err));
	  
}//end func
	  


function aftergetincomplwptappsmm(res){

if (!res.length){
	console.log("aftergetincomplwptappsmm abort: !res.length");
	return;
	}//end if

let temprows=[];
let appcount=0;
//let rowhtm=[];
res.map((col, index) => {
	
	const trkey="incomplappmm_"+index;
	const rdId="rdincomplyrs_"+index;
		
	temprows.push(
		<tr key={trkey} >
		<td align='right' style={{width:"200px"}} >
			<input type="radio" name="rdincomplyrs" id={rdId} value={col['YR']} onClick={(e)=>{handleIncompcritchange(e);}} />
			<label htmlFor={rdId} className="hand" >{col['YR']}</label>
		</td>
		<td align='right' >{col['COUNT01']}</td>
		<td align='right' >{col['COUNT02']}</td>
		<td align='right' >{col['COUNT03']}</td>
		<td align='right' >{col['COUNT04']}</td>
		<td align='right' >{col['COUNT05']}</td>
		<td align='right' >{col['COUNT06']}</td>
		<td align='right' >{col['COUNT07']}</td>
		<td align='right' >{col['COUNT08']}</td>
		<td align='right' >{col['COUNT09']}</td>
		<td align='right' >{col['COUNT10']}</td>
		<td align='right' >{col['COUNT11']}</td>
		<td align='right' >{col['COUNT12']}</td>
		<td align='right' style={{width:"100px"}} >{col['APP_COUNT']}</td>
		</tr>);
	
	appcount+=col['APP_COUNT'];
	});//end map

	temprows.push(<tr key="incomplappmm_xxx" ><th align='right' colSpan="13" >Total # of Applications:</th><th align='right'>{appcount}</th></tr>);
	
console.log("temprows.length: "+temprows.length);
setTbloverdueappsmm(temprows);
	
}//end func



function viewwpform(e, WPT_APP_ID){
console.log('viewwpform WPT_APP_ID: '+WPT_APP_ID);
e.preventDefault();
setLinkwpform({WPT_APP_ID:WPT_APP_ID});
	{/*
	setLinkwpform();
if (navWpform.current)
	navWpform.state={WPT_APP_ID:WPT_APP_ID};
navWpform.current?.click();

	*/}

}//end func


function openCity(evt, cityName) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  if (document.getElementById(cityName))
	document.getElementById(cityName).style.display = "block";

if (evt)
	if (evt.currentTarget)
		evt.currentTarget.className += " active";
	
  setCity({name:cityName});
}//end func



async function tblincomplwptapps(){

console.log("tblincomplwptapps overdueappcrit: "+JSON.stringify( overdueappcrit ));

let params = overdueappcrit;
params.office=searchcrit.tcisland==""?sessionStorage.getItem("TC_ISLAND")??"":searchcrit.tcisland;
params.processarea=searchcrit.processarea==""?sessionStorage.getItem("PROCESS_AREA")??"":searchcrit.processarea;
params.username = sessionStorage.getItem("USERNAME");


   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };		

setTbloverduewptapps([]);
setDowaitincompl({show:true});
$("body").css("cursor", "progress");
$("#greyoverlay").show();
	
 await fetch(resturl+'rarwpform/tblincomplwptapps',requestOptions)
      .then(res => res.json())
      .then(res => 	aftertblincomplwptapps(res) )
      .catch(err => console.log(err));	
	
}//end func

function aftertblincomplwptapps(res){
$("body").css("cursor", "default");
$("#greyoverlay").hide();
setDowaitincompl({show:false});

if (!res.length)
	return;


let htmrows=[];
res.map((col, index) => {

	const trkey='tr_'+index;
	const radioId='radio_'+index;
	
	const htmrow=<tr key={trkey} >
	<td align='right' >{index+1}</td>
	<td align='left' >{col['REF_NUM']}</td>
	<td align='left' >{col['SUBMITTED_TO_CSC']}</td>
	<td align='left' >{col['MPR_NAME']}</td>
	<td align='left' >{col['MPE_NAME']}</td>
	<td align='left' >{col['MPE_OCCUPATION']}</td>
	<td align='left' >{col['IPM_LBR_CLR_APP_ID']}</td>
	<td align='left' >{col['IMG_REF_NO']}</td>
	<td align='left' >{col['LC_CREATED_DATE']}</td>
	<td align='left' >{col['LC_CREATED_BY']}</td>
	<td align='left' >{col['INTEL_CLEAR']}</td>
	<td align='left' >{col['LC_STATUS']}</td>
	<td align='left' >{col['BAL_RCP_DAT']}</td>
	<td align='left' >{col['WORK_PERMIT_ID']}</td>
	<td align='left' >{col['WORK_PERMIT_NO']}</td>
	<td align='left' >{col['WP_CREATED_DATE']}</td>
	<td align='left' >{col['WP_CREATED_BY']}</td>
	<td align='left' >{col['WP_STATUS']}</td>
	<td align='left' >{col['CARD_NO']}</td>
	</tr>;
	htmrows.push(htmrow);
	

});


setTbloverduewptapps(htmrows);
	
}//end func

async function callrptincomplwptapps(e){

e.preventDefault();

let FILE_NAME="default_file_name";

/*
/*
{CALL BFADM.SP_TBL_INCOMPL_WPT_APP(
$P{OFFICE}
,$P{PROCESS_AREA}
,$P{YER}
,$P{STA}
,$P{ORACLE_REF_CURSOR}
) }


SELECT
OFFICE
, PROCESS_AREA
, '2026' YER
, 'Approved But No Balance Receipts' STA
, 1234 NUM
, SUBMITTED_TO_CSC
, LBR_CLR_APP_ID
, AGENCY
, MPR_NAME
, CASE_WORKER
, MPE_NAME
, MPE_OCCUPATION
, IMG_REF_NO
, LC_CREATED_DATE
, LC_STATUS
, WORK_PERMIT_ID
, WORK_PERMIT_NO
, WP_CREATED_DATE
, WP_STATUS
FROM TEMP_RPT_INCOMPL_WPTAPP
*/

if (!e.currentTarget.classList.contains("hidden"))
	e.currentTarget.classList.add("hidden");
	
let params = overdueappcrit;
params.office=searchcrit.tcisland==""?sessionStorage.getItem("TC_ISLAND")??"":searchcrit.tcisland;
params.processarea=searchcrit.processarea==""?sessionStorage.getItem("PROCESS_AREA")??"":searchcrit.processarea;
params.username = sessionStorage.getItem("USERNAME");

const paramsurl="reportfilepath=C:\\scripts\\IncompleteWptapp\\IncompleteWptapp.jasper"+
				"&&resultfilepath=C:\\scripts\\IncompleteWptapp\\out\\IncompleteWptapp.pdf"+
				"&&lsargs=OFFICE,PROCESS_AREA,YER,STA"+
				"&&lsvals="+params.office+","+params.processarea+","+params.yer+","+params.sta;
				
//RUNIREPORTID

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {paramsurl:paramsurl} )
  };		


 await fetch(resturl+'rarwpform/jaspertopdf',requestOptions)
		.then(res => res.json())
      .then(res => 	aftercallrptincomplwptapps(res, e, FILE_NAME) )
      .catch(err => console.log(err));

}//end func

async function aftercallrptincomplwptapps(res, e, FILE_NAME){
/*
const bs64Obj= await fsp.readFile(attFilePath, 'base64');

if (e.currentTarget.classList.contains("hidden"))
	e.currentTarget.classList.remove("hidden");
*/
// decode base64 string, remove space for IE compatibility



const bs64File=res.length?(res[0].File??""):"";

if (bs64File==""){
	console.log("abort aftercallrptoverduewptapps. empty bs64File ");
	return;
	}

var binary = atob(bs64File.replace(/\s/g, ''));
var len = binary.length;
var buffer = new ArrayBuffer(len);
var view = new Uint8Array(buffer);
for (var i = 0; i < len; i++) {
    view[i] = binary.charCodeAt(i);
}

// create the blob object with content-type "application/pdf"               
var blob = new Blob( [view], { type: "application/pdf" });
	//const blob = await res[0].File.blob();
	saveAs(blob, "filename.pdf");
}//end func

function vouchersLink(e, appid){
	console.log('setLinkvouchers '+appid);
	e.preventDefault();
	setLinkvouchers({WPT_APP_ID:appid});

}//end func


function handleWpappChange(e, WPT_APP_ID, ALLOW_TO_PROCESS){
	e.preventDefault();
	if (ALLOW_TO_PROCESS==1)
		navigate("/wptform",{state:{WPT_APP_ID:WPT_APP_ID}});
	else
		navigate("/wptovrrqs",{state:{WPT_APP_ID:WPT_APP_ID}});
	

}//end func


function toggleModalsm() {
	
if (document.querySelector(".modalsm")){
	const modalsm=document.querySelector(".modalsm");
	modalsm.classList.toggle("show-modalsm");	
	if (modalsm.classList.contains("show-modalsm")){
		//when the popup opens, focus emailmsg and addEventListeners 
		
		if (document.querySelector(".close-button")){
			const closeButton = document.querySelector(".close-button");
			if(!closeButton.classList.contains('attached-listener')){
				closeButton.classList.add('attached-listener');
				closeButton.addEventListener("click", toggleModalsm);
				window.addEventListener("click", windowOnClick);
				}//end if
			}//end if
	
		}//end if	
	}//end if

}//end func

function windowOnClick(event) {
const modalsm = document.querySelector(".modalsm");
const trigger = document.querySelector(".trigger");
const closeButton = document.querySelector(".close-button");	
	
    if (event.target === modalsm) {
    	toggleModalsm();
    }
}//end func


function searchcritChange(e){
	
let {name, value}=e.target;

if (name=="boardreview")
	value=e.target.checked?"B":"";
else if (name=="nonagency")
	value=e.target.checked?"N":"";

sessionStorage.setItem("searchcrit."+name, value);

let temp_months_span={YRMM1: searchcrit.YRMM1, YRMM2: searchcrit.YRMM2};
if (name=="months_span"){
	for (var i=0; i<arrmonthspan.length; i++)
		if (arrmonthspan[i].MONTHS_SPAN==value){
			temp_months_span.YRMM1=arrmonthspan[i].YRMM1;
			temp_months_span.YRMM2=arrmonthspan[i].YRMM2;
			}//end if
	
	}//end if

setSearchcrit((prev)=>{	
	return {...prev
		, [name]:value
		, critname: name
		, YRMM1: temp_months_span.YRMM1
		, YRMM2: temp_months_span.YRMM2
		}
	}); 
	
	
}//end func






async function getlcappealletter(e, LBR_CLR_APP_ID, UPLOAD_DIR){
	e.preventDefault();
	/*
	maybe by default hide the pdf icon if the date is past the required date
	*/
	if (!e.target.classList.contains("hidden"))
		e.target.classList.add("hidden");

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {FILE_PATH:UPLOAD_DIR+"/labourscan.pdf"} )
  };		

console.log("getlcappealletter: "+LBR_CLR_APP_ID);

  await fetch(resturl+'rarwptprocess/getlbrclrLetter',requestOptions)
	  .then(res => 	aftergetlcappealletter(e, LBR_CLR_APP_ID, res) )
      .catch(err => console.log(err));
	  
}//end func

async function aftergetlcappealletter(e, LBR_CLR_APP_ID, res){
console.log("aftergetlcappealletter: "+LBR_CLR_APP_ID);
		if (e.target.classList.contains("hidden"))
			e.target.classList.remove("hidden");
		

const blob = await res.blob();
//const blobBytesSize = blob.size;
console.log("blob.type: "+blob.type);
//VMEUS2ASYAPP02\aps
if (blob.type.startsWith("application/json")){
	let blob_text = await blob.text();
	console.log("blob_text: "+blob_text);
	const temp = JSON.parse(blob_text);
	const error=temp?(temp.error??""):"seems the file was not found on the server: ";
	alert(error);
	}
else
	saveAs(blob, "LabourClearanceAppeal"+LBR_CLR_APP_ID+".pdf");


}//end func



async function getlcletterfilepath(e, LBR_CLR_APP_ID){
	
	e.preventDefault();
	
	if (!e.target.classList.contains("hidden"))
		e.target.classList.add("hidden");

		const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {LBR_CLR_APP_ID:LBR_CLR_APP_ID, STATUS:"CHECK"} )
  };		

 await fetch(resturl+'rarwpform/getlcletterfilepath',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergetlcletterfilepath(e, LBR_CLR_APP_ID, res) )
      .catch(err => console.log(err));
	
	/*
	check lbr_clr_letter.js and SP_TBL_LBR_CLR_LETTERS for the args needed and add to SP_TBL_WPT_APPS
	*/

}//end func

async function aftergetlcletterfilepath(e, LBR_CLR_APP_ID, res){
const FILE_PATH=res.length?(res[0].FILE_PATH??""):"";

if (FILE_PATH==""){
	console.log("abort aftergetlcletterfilepath for empty FILE_PATH")
	return;
	}

const PDF_SIZE=res[0].PDF_SIZE;

if (1*PDF_SIZE==0)
	window.alert("The pdf letter may not have been generated as yet.\r\nIf it does not download you can try again after 10 minutes");

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {LBR_CLR_APP_ID:LBR_CLR_APP_ID, DEC_ID:res[0].DEC_ID, PDF_SIZE:PDF_SIZE, FILE_PATH:FILE_PATH} )
  };		

  await fetch(resturl+'rarwptprocess/getlbrclrLetter',requestOptions)
      .then(res => 	aftergetlbrclrLetter(e, LBR_CLR_APP_ID, res) )
      .catch(err => console.log(err));
	  
}//end func

async function aftergetlbrclrLetter(e, LBR_CLR_APP_ID, res){

		if (e.target.classList.contains("hidden"))
			e.target.classList.remove("hidden");
		

const blob = await res.blob();
//const blobBytesSize = blob.size;
console.log("blob.type: "+blob.type);

if (blob.type=="application/json"){
	let blob_text = await blob.text();
	console.log("blob_text: "+blob_text);
	const temp = JSON.parse(blob_text);
	const error=temp?(temp.error??""):"seems the file was not found on the server: ";
	alert(error);
	}
else
	saveAs(blob, "LabourClearanceLetter"+LBR_CLR_APP_ID+".pdf");


}//end func



async function checkifstatusinsynch(e){
	
	e.preventDefault();

const userconfirm=window.confirm("the system will check if applications in the table below\r\nhave the correct Status.  proceed?");

if (!userconfirm)
	return;

const params = {
	USERNAME: sessionStorage.getItem("USERNAME")??""
	, STATUS: tabmenu.STATUS
	, YRMM1: searchcrit.YRMM1
	, YRMM2: searchcrit.YRMM2
	};

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };		

 await fetch(resturl+'rarwpform/checkifstatusinsynch',requestOptions)
      .then(res => res.json())
      .then(res => 	aftercheckifstatusinsynch(res) )
      .catch(err => console.log(err));

}//end func

function aftercheckifstatusinsynch(res){

const UPDATE_COUNT=res.length?(res[0].UPDATE_COUNT??0):0;

if (UPDATE_COUNT==0)
	window.alert("No applications were found that need the status to be updated");
else
	showsnackbar(UPDATE_COUNT+" applications were updated.  refresh the table");

}//end func





async function gettbldefers(e, WPT_APP_ID){
	
	e.preventDefault();
	/*
	copied from wptform.js which fetches the defers together with the vchrs.
	here we do not use the vchrs.  here we use only defers
	*/	
   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {VCHR_TYPE:"LC", WPT_APP_ID: WPT_APP_ID} )
  };		

 await fetch(resturl+'rarwpform/getwptvouchers',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergetwptvouchers(res) )
      .catch(err => console.log(err));

}//end func

function aftergetwptvouchers(res){
	/*
	copied from wptform.js which fetches the defers together with the vchrs.
	here we do not use the vchrs.  here we use only defers
	*/
const defers=res[0].defers;
let defers_htmrows=[];

	defers.map((col, index) => {
		
		const key="tbldefers_"+index;
		const docNo=col['DOC_NO'];
		
		const htmrow=<tr key={key} >
					<td align="center" >{col['STAMP']}</td>
					<td align="left" >{col['DEFER_REASON']}</td>
					</tr>;
		defers_htmrows.push(htmrow);
		
		});//end map	

setTbldeferrows(defers_htmrows);
toggleModalsm();
//processarea
}//end func


function schoolChange(e){

const args={
	target:{name:"txt", value:e.target.value}
	};

searchcritChange(args);
/*
setSearchcrit((prev)=>{
	return {...prev, txt:e.target.value}
	});

*/

}//end func
	
	

	
const theadcells=<>
	<tr>
		<th align="right" >#</th>
		<th>APS<br/>ref #</th>
		<th>Case<br/>Worker</th>
		<th>
		{AD_USER=="" && 
<span className='tooltip' >
<input type="image" id="btnrevisestatus" onClick={(e)=>{checkifstatusinsynch(e);}}  src="img/refresh_palegreen.png" border="0"  height="22" title="revise application status" />
<span className='tooltiptext'>revise application status</span>
</span>
}
		&nbsp;&nbsp;status
		</th>
		<th>bal<br/>rcp</th>
		<th>submitted</th>
		<th>
			<select name="APP_TYPE" value={searchcrit.APP_TYPE} onChange={(e)=>{searchcritChange(e);}}  >
			<option value='' >-type-</option>
			{apptypeoptions}
			</select>
			
		</th>
		<th>isl</th>
		<th>
			<select name="AGENCY" value={searchcrit.AGENCY} onChange={(e)=>{searchcritChange(e);}} style={{width:"140px"}} >
			<option value='' >* * * agencies * * *</option>
			{agencyoptions}
			</select>
		</th>
		<th>employer's name</th>
		{/*<th>employer's phone #</th>*/}
		<th>immig.<br/>ref. #</th>
		<th>applicant</th>
		<th>job title</th>
		<th>first viewed</th>
	</tr>

</>;

const ASSIGNED_TO_CW=sessionStorage.getItem("ASSIGNED_TO_CW")?sessionStorage.getItem("ASSIGNED_TO_CW"):"";

const PROCESS_AREA=(sessionStorage.getItem("searchcrit.processarea")=="Corporate"||sessionStorage.getItem("PROCESS_AREA")=="Corporate")?"Corporate":"General";

let cbastome="";
if (ASSIGNED_TO_CW!="")
	cbastome="checked";


	//console.log("AD_USER: " + AD_USER);
	{/*<a href="#" onClick={(e)=>{e.preventDefault();navigate("/wptappstoemail");}} ><img src="img/emaillg.png" border="0" height="28" /><span className='tooltiptext'>open email queue</span></a>*/}
	
  return (
    <>
<form id="form1" onSubmit={(e)=>{submitSearchform(e);}}  >
<table align='center' border="0" width="87%" style={{marginTop:"10px", marginBottom:"10px"}}>
<tbody>
<tr>
<td><select name="months_span"       value={searchcrit.months_span} onChange={(e)=>{searchcritChange(e);}} >{combodates}</select></td>
<td><select name="processarea" value={searchcrit.processarea} onChange={(e)=>{searchcritChange(e);}} style={{width:"80px"}} >{processareaopts}</select></td>
<td align='center' >
search criteria:&nbsp;<input name="txt" size='30' value={searchcrit.txt} autoComplete="off" style={{textAlign:"center"}} onChange={(e)=>{searchcritChange(e);}} onFocus={(e)=>{e.target.select();}} 
title="'Immig. Ref # / Portal Ref # / Passport # / Name / Job Title'"
placeholder="Immig. Ref # / Portal Ref # / Passport # / Name / Job Title" />
&nbsp;&nbsp;<span className='tooltip' >
<input type="image" id="btnsearch" src="img/searchglass.png" border="0" title="click here or hit enter to search" />
<span className='tooltiptext'>click here or hit enter to search</span>
</span>
</td>
<td>
{
AD_USER!="" &&	
<select name="tcisland" value={searchcrit.tcisland} onChange={(e)=>{searchcritChange(e);}} style={{width:"80px"}} >{officeopts}</select>
}
</td>
<td align='center' className='tooltip' ><input size="2" name="inputminsremain" value={countdown.min+':'+countdown.sec} style={{textAlign:"center"}} readOnly className="gnsbro" /><span className='tooltiptext'>minutes before reload</span></td>

<td align='center'  >
<a href="#" className="nodecor" onClick={(e)=>{e.preventDefault(); navigate("/apsupdates");  }} ><img src='img/updates_icon.png' border='0' /> Updates {sessionStorage.getItem("APS_NEWS_DATE")??""}</a>
</td>
</tr>
</tbody>
</table>
</form>

{
AD_USER!="" && <table align='center' border="0" width="70%" >
<tbody>
<tr>
<td align='center' >
	<input id="cbastome" checked={cbastome} onClick={(e)=>{assignedToMe(e);}} type="checkbox" onChange={(e)=>{searchcritChange(e);}} /><label htmlFor="cbastome" className="hand" >assigned to me</label>
</td>
 
 {
	 
	PROCESS_AREA=="Corporate"
	&& 		<td align='center' >
			<a href="school" className="nodecor" ><img src="img/openlink.png" height="24" border="0" /></a>
			&nbsp;
			Schools:&nbsp;
			<select name="schoolname" onChange={(e)=>{ schoolChange(e); }} style={{width:"180px"}}  >
			<option key='schoolopt001' value=''></option>
			<option key='schoolopt002' value='All Government Schools'>All Schools</option>
			{schoolopts}
			</select>	 
			</td>
	 
 }


	<td align='center'  >
	<input type="checkbox" id="cbnonagency" value="N" name="nonagency" onClick={(e)=>{searchcritChange(e); }} /><label htmlFor="cbnonagency" className="hand" >non agency</label>
	</td>	

		<td align='center'  >
	<input type="checkbox" id="cbboardrvw" value="B" name="boardreview" onClick={(e)=>{searchcritChange(e); }} /><label htmlFor="cbboardrvw" className="hand" >board review apps</label>
	</td>

<td align='center'  >
<a href="#" className="nodecor" onClick={(e)=>{e.preventDefault(); window.open("/imgrefseq"); }} ><img src="img/abc-block.png" height="30" border="0" /> Immig. Ref #</a>
</td>
<td align='center'  >
<a href="#" className="nodecor" onClick={(e)=>{e.preventDefault(); window.open("/adminreport"); }} ><img src="img/reports.png" height="30" border="0" /> Reports</a>
</td>
<td align='center'  >
 {
	 PROCESS_AREA=="General" && 
	 <a href="startlettercaseworker" className="nodecor" ><img src="img/abc-block.png" height="30" border="0" /> Case Workers</a>
 }
</td>


</tr>
</tbody>
</table>
}
	

<div className="tab">
  <button className="tablinks" id='newapps'    onClick={(e)=>{openCity(e, e.target.id+"tc");}} >New Applic. <span className="brown" >{statuscounts.NEW}</span></button>
  <button className="tablinks" id='unpaidapps' onClick={(e)=>{openCity(e, e.target.id+"tc");}} >Unpaid <span className="brown" >{statuscounts.UNPAID}</span></button>
  <button className="tablinks" id='newlypaidapps'   onClick={(e)=>{openCity(e, e.target.id+"tc");}} >Paid <span className="brown" >{statuscounts.PAID}</span></button>
  <button className="tablinks" id='processingapps'   onClick={(e)=>{openCity(e, e.target.id+"tc");}} >Processing <span className="brown" >{statuscounts.PROCESSING}</span></button>
  <button className="tablinks" id='approvedapps'   onClick={(e)=>{openCity(e, e.target.id+"tc");}} >Approved <span className="brown" >{statuscounts.APPROVED}</span></button>
  <button className="tablinks" id='wrkpmtapps'   onClick={(e)=>{openCity(e, e.target.id+"tc");}} >Work Pmt <span className="brown" >{statuscounts.WORK_PERMIT}</span></button>
  <button className="tablinks" id='wpcardapps'   onClick={(e)=>{openCity(e, e.target.id+"tc");}} >Cards <span className="brown" >{statuscounts.WP_CARD}</span></button>
  <button className="tablinks" id='refusedapps'   onClick={(e)=>{openCity(e, e.target.id+"tc");}} >Refuse <span className="brown" >{statuscounts.REFUSED}</span></button>
  <button className="tablinks" id='lcappealapps'   onClick={(e)=>{openCity(e, e.target.id+"tc");}} >Appeal <span className="brown" >{statuscounts.APPEALED}</span></button>
{/*
AD_USER!="" &&	<>
  <button className="tablinks" id='overduelcrwpt'   onClick={(e)=>{openCity(e, e.target.id+"tc");}} >Incompl</button>

</>
*/}  
  
  
</div>



{dowait.show && <div align='center' ><img src='img/Loading_2.gif' border='0' height='36' /> . . . please wait</div>}	


<div id="newappstc" className="tabcontent">
  <h4 align='center' >Newly Submitted Applications to be checked.  After checking, payment vouchers prepared if the applicaiton is not refused</h4>
	<table align='center' className='customers'  >
	<thead>
	{theadcells}
	</thead>
	<tbody>
		{!dowait.show && tblwptapps.newrows}
	</tbody>
	</table>
</div>

<div id="unpaidappstc" className="tabcontent">
  <h4 align='center' >Applications with payment vouchers prepared and not yet paid</h4>
  
	<table align='center' className='customers'  >
	<thead>
	{theadcells}
	</thead>
	<tbody>
		{!dowait.show && tblwptapps.unpdrows}
	</tbody>
	</table>
</div>

<div id="newlypaidappstc" className="tabcontent">
  <h4 align='center' >Applications with status Paid or Reviewed</h4>
  <div align="center">If Paid application does not move to Reveiewed/Processing automatically, that means there is a problem exporting the paid application.</div>
	<table align='center' className='customers'  >
	<thead>
	{theadcells}
	</thead>
	<tbody>
		{!dowait.show && tblwptapps.revwdrows}
	</tbody>
	</table>
</div>	


<div id="processingappstc" className="tabcontent">
  <h4 align='center' >Applications being Processed</h4>
  {
	 AD_USER!="" &&
	  <div  align='center'>
	  <select name="LETTER_RANGE" value={searchcrit.LETTER_RANGE}  onChange={(e)=>{searchcritChange(e);}}  >
	  <option value='' >- Letter Filter -</option>
	  <option value='A - G' >A - G</option>
	  <option value='H - N' >H - N</option>
	  <option value='O - T' >O - T</option>
	  <option value='U - Z' >U - Z</option>
	  </select>
	  &nbsp;&nbsp;
	  <a href="#" className="nodecor" id="btn_incompl_app_by_cswkr" onClick={(e)=>{incompl_app_by_cswkr(e);}} ><img src="img/pdf.gif" border="0"  /> Applications Not Completed Report</a>
	  </div>
  }
  <table align='center' className='customers'  >
	<thead>
	{theadcells}
	</thead>
	<tbody>
		{!dowait.show && tblwptapps.processingrows}
	</tbody>
	</table>
</div>	


<div id="approvedappstc" className="tabcontent">
  <h4 align='center' >Labour Clearance Applications Approved or Awaiting Approval</h4>
	<table align='center' className='customers'  >
	<thead>
	{theadcells}
	</thead>
	<tbody>
		{!dowait.show && tblwptapps.apprvdrows}
	</tbody>
	</table>
</div>	

<div id="wrkpmtappstc" className="tabcontent">
  <h4 align='center' >Work Permit Applications (created after Balance Receipts are paid)</h4>
  
  			{!dowait.show && AD_USER=="ajones" && <>
				<table align="center" >
				<tbody>
				{wrkpmtstatusrows}
				</tbody>
				</table>
				<br/>
				<img id='signat_img' src={"data:image/png;base64, "+wptapp.SIGNAT} border='0' width="200" />
				</>
			}
  
	<table align='center' className='customers'  >
	<thead>
	{theadcells}
	</thead>
	<tbody>
		{!dowait.show && tblwptapps.wrkpmtrows}
	</tbody>
	</table>
</div>	

<div id="wpcardappstc" className="tabcontent">
  <h4 align='center' >Work Permit Cards printed</h4>
  <div align='center' className="brown" >Note: In the event of print error, you may have to wait for a new card to be printed</div>
	<table align='center' className='customers'  >
	<thead>
	{theadcells}
	</thead>
	<tbody>
		{!dowait.show && tblwptapps.wpcardrows}
	</tbody>
	</table>
</div>	






<div id="refusedappstc" className="tabcontent">
  <h4 align='center' >Applications Deferred/Denied</h4>
  <div  align='center'>
  <a href="#" className="nodecor" id="btn_rptManwrtoffapps" onClick={(e)=>{rptManwrtoffapps(e);}} ><img src="img/recycle.png" border="0"  /> report of Manually Written Off Applications</a>
  </div>
	<table align='center' className='customers'  >
	<thead>
	{theadcells}
	</thead>
	<tbody>
		{!dowait.show && tblwptapps.rfsdrows}
	</tbody>
	</table>
</div>	


<div id="lcappealappstc" className="tabcontent">
  <h4 align='center' >Responses to Deferred or Denied Labour Clearance Applications</h4>
  <div align='center' >Requires uploading a document to the Deferred Labour Clearance line on the Manage Files page</div>
	<table align='center' className='customers'  >
	<thead>
	{theadcells}
	</thead>
	<tbody>
		{!dowait.show && tblwptapps.lcappealrows}
	</tbody>
	</table>
</div>	





	<div className="modalsm">
		<div className="modalsm-content">
			<span className="close-button">&times;</span>
			<div align='center' id='modalsmtext' >
			
				{
				tbldeferrows.length>0 && <>
					<p align="center" className="Acme" style={{marginBottom:"0px", marginTop:"9px", color:"brown",fontSize:"20px"}} >Table of Reason(s) for Deferal</p>
					<table align="center" className="customers" style={{width:"80%"}} >
					<thead>
					<tr>
					<th align="left" >Date</th>
					<th align="left" >Reason</th>
					</tr>
					</thead>
					<tbody>
					{tbldeferrows}
					</tbody>
					</table>
					</>
				}
				
			</div>
		</div>
	</div>




<div id="snackbar">&nbsp;</div>

{/*<input name="FIRST_MONTHS_SPAN" type="text" />*/}
<input name="YRMM1" value={searchcrit.YRMM1} type="hidden"  />
<input name="YRMM2" value={searchcrit.YRMM2}  type="hidden" />

          <NavLink
		  ref={navWpform}
          to={"/wptform"}
		  style={{display:"none"}}
          state={{
		  WPT_APP_ID:linkwpform.WPT_APP_ID
		  }} 
        >
		&nbsp;click here to wpform
        </NavLink>

          <NavLink
		  ref={navWpvouchers}
          to={"/wpvouchers"}
		  style={{display:"none"}}
          state={{
		  WPT_APP_ID:linkvouchers.WPT_APP_ID
		  }} 
        >
		&nbsp;click here to vouchers
        </NavLink>
		{/*
		
        <NavLink ref={navWpform} to={"/wpform"} style={{display:"none"}}
          state={{WPT_APP_ID:0}}  >wpform</NavLink>
		*/}



    </>
  );
  


};


export default RenderWpForm;